import {Component, OnInit, Input, Output, HostListener, ElementRef, ViewChild} from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../services/http-service.service';
import { CensusProvider } from '../../providers';
import Quill from 'quill';
import BlotFormatter from 'quill-blot-formatter';
import { CensusGeo } from '../../model/census.geo';
import { ContentBlockTableType } from '../../model/table-type';
import {fromEvent} from "rxjs";
import {debounceTime, distinctUntilChanged, map} from "rxjs/operators";
Quill.register('modules/blotFormatter', BlotFormatter);
@Component({
  selector: 'editable-text',
  templateUrl: './editable-text.component.html',
  styleUrls: ['./editable-text.component.scss']
})

export class EditableTextComponent implements OnInit {

  @Input() text;
  @Input() isEditMode;
  @Input() order;
  @Input() columns;
  @Input() tableType;
  @Output() modeChange = new EventEmitter();
  @Output() tableChange = new EventEmitter();

  @ViewChild('inputText', {static: false}) inputRef: ElementRef;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '250px',
    maxHeight: '400px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: true,
    toolbarPosition: 'top'
  };
  quillModules = {
    blotFormatter: {},
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'align': [] }],
      ['link', 'image'],
      ['clean'],
    ]
  };
  loading = false;
  isAddColumn:boolean = false;
  columnName:string = '';
  searchResultLocation:CensusGeo[] = [];
  searchResults:string[] = [];
  showSearchLoading:boolean = false;

  constructor(
    public httpClient:HttpClient,
    public httpService:HttpService,
    public censusProvider:CensusProvider,
    private eRef: ElementRef
  ) { }

  @HostListener('document:click', ['$event'])
  clickout(): void {
    this.displayAutoComplete(true);
  }

  ngOnInit(): void {
    if(this.text === '' && (this.tableType === ContentBlockTableType.DEMOGRAPHICS || this.tableType === ContentBlockTableType.FINANCIALS))
      this.reloadTable();
  }

  ngOnChanges(change): void {
    if(change.isEditMode){
      this.isEditMode = change.isEditMode.currentValue;
    }
    if(change.order){
      this.order = change.order.currentValue;
    }
  }

  // changeToEditMode() - Change to edit mode when no data found.
  changeToEditMode(): void {
    if(this.isEditMode){
      this.isEditMode = !this.isEditMode;
      this.modeChange.emit(this.isEditMode);
    }
  }

  // removeColumn() - Remove column at given index.
  removeColumn(index:number): void{
    this.columns.splice(index, 1);
  }

  // reloadTable() - Reload table.
  reloadTable(): void {
    this.loading = true;
    this.httpService.rebuildTable(this.columns, this.tableType).subscribe(response => {
      if(response.success && response['result']){
        this.text = response.result;
        this.tableChange.emit({ TEXT: this.text, COLUMNS: this.columns });
      }
      this.loading = false;
    }, (error) => {
      this.loading = false;
      if (error) {
        //this.toastrService.error(error.message);
      }
    });
  }

  // addColumn() - Toggle variable to add new column.
  addColumn(): void {
    this.isAddColumn = true;
    setTimeout(() => {
      this.subscribeCensusLocationSearch();
    }, 1)
  }

  // selectLocation() - Select value to Add column.
  selectLocation(column: string): void {
    let tmpLocations = JSON.parse(JSON.stringify(this.searchResultLocation));
    tmpLocations.map((location) => {
      if(location.name === column){
        this.columns.unshift(location);
        this.columnName = '';
        this.isAddColumn = false;
        this.searchResultLocation = [];
        this.searchResults = [];
      }
    });
  }

  // hideAutoComplete() - Hide auto complete input box.
  hideAutoComplete(): void {
    if(!document.getElementsByClassName('autoCompleteInput')[0].classList.contains('d-none')){
      document.getElementsByClassName('autoCompleteInput')[0].classList.add('d-none');
    }
  }

  // displayAutoComplete() - Display auto complete box.
  displayAutoComplete(isOnlyRemove:boolean): void {
    if(isOnlyRemove){
      if(document.getElementsByClassName('autoCompleteInput').length > 0 && !document.getElementsByClassName('autoCompleteInput')[0].classList.contains('d-none')){
        document.getElementsByClassName('autoCompleteInput')[0].classList.add('d-none');
      }
    }else{
      if(this.columnName.length > 0 && document.getElementsByClassName('autoCompleteInput').length > 0 && document.getElementsByClassName('autoCompleteInput')[0].classList.contains('d-none')){
        document.getElementsByClassName('autoCompleteInput')[0].classList.remove('d-none');
      }else if(document.getElementsByClassName('autoCompleteInput').length > 0){
        document.getElementsByClassName('autoCompleteInput')[0].classList.add('d-none');
      }
    }
  }

  // getLocations() - Get locations on search value.
  getLocations(event): void {
    this.displayAutoComplete(false);
    this.showSearchLoading = true;
    this.censusProvider.search(event).subscribe(response => {
      this.searchResultLocation = [];
      this.searchResults = [];
      if(response.success && response['result'] && response['result'].response?.options?.length > 0){
        response['result'].response.options.map(location => {
          if(location?.type === 'geography') {
            let tmp: CensusGeo = new CensusGeo();
            tmp.name = location.title;
            tmp.code = location.facets?.geography?.length > 0 ? location.facets.geography[0] : '';

            this.searchResultLocation.push(tmp);
            this.searchResults.push(tmp.name);
          }
        });
      }
      this.showSearchLoading = false;
    }, (error) => {
      if (error) //this.toastrService.error(error.message);
      this.showSearchLoading = false;
    });
  }

  /** Subscribe to search */
  subscribeCensusLocationSearch(): void{
    if(this.inputRef) {
      const eventStream = fromEvent(this.inputRef.nativeElement, 'keyup')
        .pipe(
          map(() => this.columnName),
          debounceTime(500),
          distinctUntilChanged());

      eventStream.subscribe(input => {
        this.getLocations(this.columnName);
      });
    }
  }

}
